<template>
  <div id="shop-product-item">
    <v-container fluid grid-list-xs>
      <v-layout align-center row wrap>
        <v-flex sm8 xs12>
          <div class="subheading">Product Item Price</div>
        </v-flex>
        <v-flex sm4 text-xs-center xs12>
          <ShopEditionProductItemPriceDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            class="elevation-0"
            disable-initial-sort
            :headers="headers"
            hide-actions
            :items="states"
            :loading="tableLoading"
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.name || '-' }}</td>
                <td>{{ props.item.price || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const ShopEditionProductItemPriceDialog = () =>
  import('@/components/admin/ShopEditionProductItemPriceDialog')
export default {
  name: 'shop-product-item',
  components: {
    ShopEditionProductItemPriceDialog
  },
  data() {
    return {
      tableLoading: false,
      headers: [
        { text: 'Name', align: 'left', value: 'name', width: '300' },
        { text: 'Price', align: 'left', value: 'price', width: '300' }
      ]
    }
  },
  computed: {
    states() {
      return this.$store.getters['ShopEditionProductItemPrice/getAll'].filter(
        item => item.shopEditionProductItemId == this.shopEditionProductItemId
      )
    },
    shopEditionProductItemId() {
      return this.$store.state.ShopEditionProductItem.idx
    }
  },
  created() {
    if (this.$store.state.ShopEditionProductItemPrice.data.length === 0)
      this.$store.dispatch('ShopEditionProductItemPrice/fetch')
  },
  methods: {
    editItem(idx) {
      this.$store.commit('ShopEditionProductItemPrice/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProductItemPrice/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
